import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="max-w-[1600px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <Reveal>
          <Overline>About Jigel</Overline>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tighter mt-4 max-w-4xl leading-[0.95]">
            Premium fashion, <span className="italic font-light text-wine">given another life.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-ink/60 text-base lg:text-lg leading-relaxed">
            JIGEL is a premium clothing recommerce platform. We acquire eligible pre-owned clothing from customers, evaluate every piece, and give each item an appropriate outcome — resale, Cloth Cash, or responsible recovery.
          </p>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-3 gap-px bg-border border border-border">
          {[
            ["Shop", "Carefully selected second-life fashion from premium brands — inspected, graded and honestly priced."],
            ["Sell", "Submit clothes you no longer wear. Reusable pieces earn cash; good pieces earn Cloth Cash; well-worn pieces join Recovery."],
            ["Repeat", "Your Cloth Cash works at JIGEL and AVAGINJA. Sell, earn, shop — the cycle keeps fashion moving forward."],
          ].map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.1} className="bg-ivory p-8 md:p-10">
              <span className="font-serif text-5xl text-wine/20">{String(i + 1).padStart(2, "0")}</span>
              <h2 className="font-serif text-3xl mt-4">{t}</h2>
              <p className="mt-3 text-sm text-ink/55 leading-relaxed">{d}</p>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-16 border border-gold/50 bg-gold/5 p-8 md:p-10 max-w-3xl">
          <p className="text-[11px] tracking-[0.3em] uppercase text-gold">Our Standard</p>
          <p className="mt-4 font-serif text-2xl leading-snug">
            Not every item we receive becomes a JIGEL product. Only items that meet our resale standards are offered to another customer.
          </p>
          <p className="mt-4 text-sm text-ink/60 leading-relaxed">
            Every pre-owned piece carries a JIGEL Grade (A, B or C), honest condition notes and real photographs. We only claim an item is authenticated, cleaned or repaired when that work has actually been done.
          </p>
        </Reveal>
        <Reveal className="mt-12 flex flex-wrap gap-4">
          <Link to="/shop" data-testid="about-shop" className="bg-ink text-ivory px-8 py-4 text-[11px] tracking-[0.25em] uppercase flex items-center gap-3 hover:bg-wine transition-colors">Shop Now <ArrowRight size={14} strokeWidth={1.5} /></Link>
          <Link to="/sell" data-testid="about-sell" className="bg-gold text-ink px-8 py-4 text-[11px] tracking-[0.25em] uppercase hover:bg-ink hover:text-ivory transition-colors">Sell Your Clothes</Link>
        </Reveal>
      </section>
    </div>
  );
}
